import store from "./store";

const setData = (value) => {
  return {
    type: 'SET_DATA',
    value,
  }
}
const setDriverData = (value) => {
  return {
    type: 'SET_DRIVER_DATA',
    value,
  }
}
const setError = (value) => {
  return {
    type: 'SET_ERROR',
    value,
  }
}
const setLocation = (value) => {
  return {
    type: 'SET_LOCATION',
    value,
  }
}
/**********************_______personnel_____************************/

const setPersonnel= (value) => {
  return {
    type: "SET_PERSONNELS",
    value,
  };
};



export { setData, setDriverData,  setError, setPersonnel ,setLocation}